import React, { Component } from "react";
import { Accordion, Page } from "../../components";
import {
  Basics,
  EvaluateContext,
  PushAndPullFactors,
  RiskAndResilience,
  TheoryOfChange,
  GoalsAndObjectives,
  Activities,
  GoalsAndActivities,
  Indicators,
  DataCollectionMethods,
  ResourcesAndLimitations,
  ProjectingResults,
  EvaluatingResults,
  ActualResults,
  ActualMap,
  Resources,
  IndicatorGenerator,
} from "./Formularies";

class InsideProject extends Component {
  componentDidMount() {}
  render() {
    const url = window.location.href.split("#")[1];
    console.log(url);

    return (
      <Page title="Project">
        <Accordion {...this.props}>
          <Accordion.Card
            {...this.props}
            open={!!!url || url == "basics"}
            match={this.props.match}
            title="BASICS"
            keyId="basics"
            style={{ marginBottom: "16px" }}
            component={Basics}
          />
          <Accordion.Card
            open={url == "evaluate-context"}
            match={this.props.match}
            title="EVALUATE CONTEXT"
            keyId="evaluate-context"
            style={{ marginBottom: "16px" }}
            component={EvaluateContext}
          />
          <Accordion.Card
            open={url == "push-and-pull-factors"}
            match={this.props.match}
            title="PUSH AND PULL FACTORS"
            keyId="push-and-pull-factors"
            style={{ marginBottom: "16px" }}
            component={PushAndPullFactors}
          />
          <Accordion.Card
            open={url == "risk-and-resilience"}
            match={this.props.match}
            title="RISK AND RESILIENCE"
            keyId="risk-and-resilience"
            style={{ marginBottom: "16px" }}
            component={RiskAndResilience}
          />
          <Accordion.Card
            open={url == "theory-of-change"}
            match={this.props.match}
            title="THEORY OF CHANGE"
            keyId="theory-of-change"
            style={{ marginBottom: "16px" }}
            component={TheoryOfChange}
          />
          <Accordion.Card
            open={url == "goals-and-objectives"}
            match={this.props.match}
            title="GOALS AND OBJECTIVES"
            keyId="goals-and-objectives"
            style={{ marginBottom: "16px" }}
            component={GoalsAndObjectives}
          />
          <Accordion.Card
            open={url == "activities"}
            match={this.props.match}
            title="ACTIVITIES"
            keyId="activities"
            style={{ marginBottom: "16px" }}
            component={Activities}
          />
          <Accordion.Card
            open={url == "goals-and-activities"}
            match={this.props.match}
            title="GOALS AND ACTIVITIES"
            keyId="goals-and-activities"
            style={{ marginBottom: "16px" }}
            component={GoalsAndActivities}
          />
          <Accordion.Card
            open={url == "indicators"}
            match={this.props.match}
            title="INDICATORS"
            keyId="indicators"
            style={{ marginBottom: "16px" }}
            component={Indicators}
          />
          <Accordion.Card
            open={url == "indicator-generator"}
            match={this.props.match}
            title="INDICATOR GENERATOR"
            keyId="indicator-generator"
            style={{ marginBottom: "16px" }}
            component={IndicatorGenerator}
          />
          <Accordion.Card
            open={url == "data-collection-methods"}
            match={this.props.match}
            title="DATA COLLECTION METHODS"
            keyId="data-collection-methods"
            style={{ marginBottom: "16px" }}
            component={DataCollectionMethods}
          />
          <Accordion.Card
            open={url == "resources-and-limitations"}
            match={this.props.match}
            title="RESOURCES AND LIMITATIONS"
            keyId="resources-and-limitations"
            style={{ marginBottom: "16px" }}
            component={ResourcesAndLimitations}
          />
          <Accordion.Card
            open={url == "actual-results"}
            match={this.props.match}
            title="CAPTURING RESULTS"
            keyId="actual-results"
            style={{ marginBottom: "16px" }}
            component={ActualResults}
          />
          <Accordion.Card
            open={url == "results-display"}
            match={this.props.match}
            title="RESULTS DISPLAY"
            keyId="results-display"
            component={ActualMap}
            style={{ marginBottom: "16px" }}
          />

          <Accordion.Card
            open={url == "resources"}
            match={this.props.match}
            title="RESOURCES"
            keyId="resources"
            component={Resources}
            style={{ marginBottom: "16px" }}
            style={{ marginBottom: 120 }}
          />
        </Accordion>
      </Page>
    );
  }
}

export default InsideProject;



// WEBPACK FOOTER //
// ./src/routers/Projects/InsideProject.js